import { render, staticRenderFns } from "./RatingViewContainer.vue?vue&type=template&id=13b669e0&"
import script from "./RatingViewContainer.vue?vue&type=script&lang=ts&"
export * from "./RatingViewContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports